import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
const GOOGLE_REVIEW_URL = 'https://g.page/r/Cat9FuHdU1RAEBM/review';
interface FirstScanReviewModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function FirstScanReviewModal({
  isOpen,
  onClose
}: FirstScanReviewModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  const handleLeaveReview = () => {
    window.open(GOOGLE_REVIEW_URL, '_blank', 'noopener,noreferrer');
    onClose();
  };
  return <AnimatePresence data-id="element-2357">
      {isOpen && <div className="fixed inset-0 z-[99999] flex items-center justify-center p-4" data-id="element-2358">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-2359" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative bg-white rounded-2xl p-8 max-w-md w-full text-center shadow-2xl z-10" data-id="element-2360">
            <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-2361">
              <X size={20} data-id="element-2362" />
            </button>

            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-2363">
              <span className="text-3xl" data-id="element-2364">🎉</span>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-2365">
              First Scan Complete!
            </h2>

            <p className="text-gray-600 mb-8" data-id="element-2366">
              How did it go? If ToxicDetector helped you see things more
              clearly, we'd love it if you could leave a quick review. It helps
              others find the clarity they need.
            </p>

            <button onClick={handleLeaveReview} className="w-full py-3 px-6 bg-purple-600 hover:bg-purple-700 text-white font-semibold rounded-xl transition-colors mb-3 flex items-center justify-center gap-2" data-id="element-2367">
              <span className="text-xl" data-id="element-2368">⭐</span>
              Leave a Review
            </button>

            <button onClick={() => {
          localStorage.setItem('first_scan_review_dismissed', 'true');
          onClose();
        }} className="w-full py-3 px-6 bg-gray-50 hover:bg-gray-100 text-gray-600 font-medium rounded-xl transition-colors" data-id="element-2369">
              Remind Me Later
            </button>
          </motion.div>
        </div>}
    </AnimatePresence>;
}